import {
  LOGOUT,
  CHECK_AUTHENTICATION,
  LOGIN,
} from './../../mutation-types';

import utils from './../../../services/utils';

export default {
  [CHECK_AUTHENTICATION](state) {
    state.authenticated = utils.defaultSession.isNotDefault();
    /*
    if (state.authenticated) {
      api.defaults.headers.common.Authorization = `Token ${localStorage.getItem('id_token')}`;
    }
    */
  },

  [LOGIN](state, token) {
    state.authenticated = true;
    localStorage.setItem('id_token', token);
    /*
      api.defaults.headers.common.Authorization = `Token ${token}`;
    */
  },

  [LOGOUT](state) {
    state.authenticated = false;
    localStorage.removeItem('id_token');
    utils.defaultSession.setDefault();
    /*
    api.defaults.headers.common.Authorization = '';
    */
  },
};



// WEBPACK FOOTER //
// ./src/app/store/modules/auth/mutations.js